export default {
  active_orders: {
    title: 'Actieve bestellingen',
  },
  order_history: {
    title: 'Bestelgeschiedenis',
  },
  menu: {
    title: 'Menu',
  },
  printer_settings: {
    title: 'Printerinstellingen',
  },
  order_control: {
    title: 'Bestelbeheer',
  },
  busy_mode: {
    title_zero: 'Drukke modus',
    title_other: 'Drukke modus (+{{time}} min)',
  },
  volume: {
    title: 'Volume',
  },
  switch_language: {
    title: 'Taal wisselen ({{language}})',
  },
  logout: {
    title: 'Uitloggen',
    description: 'Weet je zeker dat je wilt uitloggen?',
    buttons: {
      confirm: 'Ja',
      cancel: 'Annuleren',
    },
  },
};
